module.exports = __webpack_public_path__ + "img/ne.5c109026.svg";